import { kebabCase } from 'lodash';

import { useComparableMonthField } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const FlexBuyComparableRow = () => {
    const { label, value } = useComparableMonthField();

    return <ReadOnlyValueRow rowKey="flexBuyComparable" label={label} value={value} labelTestId={kebabCase(label)} />;
};
